import type { EntryChoice } from '@koob/ui/src/features/tripWizard/types';
import { useTripFilters } from '../../hooks/useTripStoreSelectors';
import DesignTripWizard, {
  type DesignTripWizardProps,
} from './DesignTripWizard';

interface Props extends Pick<
  DesignTripWizardProps,
  'editId' | 'seedComposition'
> {
  open: boolean;
  close: () => void;
  // Cancelling; defaults to close.
  onExit?: () => void;
  // Edit the trip in the store instead of starting one.
  update?: boolean;
  // Go straight to the first step (resuming a draft or a template).
  skipChooser?: boolean;
  // The entry screen's tiles (create, chooser shown).
  entryChoices?: EntryChoice[];
}

// The wizard as an overlay the app opens and closes.
export function DesignTripModal({
  open,
  close,
  onExit,
  update = false,
  skipChooser = false,
  entryChoices,
  editId,
  seedComposition,
}: Props) {
  const tripFilters = useTripFilters();

  if (!open) return null;

  return (
    <DesignTripWizard
      // The wizard reads its seed once, on mount: remount when a trip lands in
      // the store (template picked, draft loaded).
      key={tripFilters?.tripId ?? 'new'}
      mode={update ? 'edit' : 'create'}
      editId={editId}
      // An edited trip keeps its own pax.
      seedComposition={update ? undefined : seedComposition}
      seedFromTrip
      entryChoices={update || skipChooser ? undefined : entryChoices}
      startImmediately={!update && skipChooser}
      // Saving moves on by itself (host afterSave); close must not also
      // navigate, or a back-nav races it and wins.
      onDone={close}
      onExit={onExit ?? close}
    />
  );
}

export default DesignTripModal;
